import React, { useCallback } from 'react';
import { nullFn, buildNewRangeFromValue } from '../utils';
import { useCurrentDateFromValue, useRangeFromValue } from '../hooks';
import { DatePickerInputCalendarProps } from '../types';
import SingleCalendar from './calendar/SingleCalendar';
import DoubleCalendar from './calendar/DoubleCalendar';

export function DatePickerInputCalendar({
  id = undefined,
  value = undefined,
  maxValue = undefined,
  minValue = undefined,
  onChange = nullFn,
  className = undefined,
  style = undefined,
  locale = 'en-US',
  selectionType = 'single',
  variant = 'single',
}: DatePickerInputCalendarProps): JSX.Element {
  const currentValue = useCurrentDateFromValue(value);
  const range = useRangeFromValue(value, selectionType);
  const handleChange = useCallback(
    (newValue: Date | undefined) => {
      if (selectionType === 'single') return onChange(newValue);
      const result = buildNewRangeFromValue(newValue, range);
      if (!result) return undefined;
      return onChange(result.range);
    },
    [selectionType, onChange, range],
  );

  return variant === 'double' ? (
    <DoubleCalendar
      id={id}
      selectionType={selectionType}
      locale={locale}
      value={currentValue}
      selectedRange={range}
      onChange={handleChange}
      className={className}
      style={style}
      minValue={minValue}
      maxValue={maxValue}
    />
  ) : (
    <SingleCalendar
      id={id}
      selectionType={selectionType}
      locale={locale}
      value={currentValue}
      selectedRange={range}
      onChange={handleChange}
      className={className}
      style={style}
      minValue={minValue}
      maxValue={maxValue}
    />
  );
}
